import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../lib/auth";
import { errMsg } from "../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="hidden flex-col justify-between bg-slate-900 p-12 lg:flex">
        <div className="text-xl font-extrabold"><span className="text-orange-500">360RGE</span> <span className="text-slate-200">Lead Finder</span></div>
        <div>
          <h1 className="text-4xl font-extrabold leading-tight tracking-tight text-white">Find restaurants.<br />Research them automatically.<br /><span className="text-orange-500">Walk in with evidence.</span></h1>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-slate-400">Discovery via Google Places, public website and web research, and AI-structured findings — every claim linked to a source.</p>
        </div>
        <div className="text-xs text-slate-500">Internal tool · 360 Digital Marketing</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="fade-up w-full max-w-sm space-y-5" data-testid="login-form">
          <div>
            <div className="mb-6 text-lg font-extrabold lg:hidden"><span className="text-orange-600">360RGE</span> Lead Finder</div>
            <h2 className="text-2xl font-bold tracking-tight">Sign in</h2>
            <p className="mt-1 text-sm text-slate-500">Accounts are created by an administrator.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          {error && <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</div>}
          <Button type="submit" disabled={busy} className="w-full bg-orange-600 hover:bg-orange-700" data-testid="login-submit-btn">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
